export default __webpack_public_path__ + "static/media/GreiffPremiumSf.1effbf7d.jpeg";